import React from 'react';
import { Button, Segment } from 'semantic-ui-react'
import MaskedInput from 'react-text-mask'
import MediaQuery from 'react-responsive'
import Mensagens from '../../Mensagens';

class InscricaoExterno extends React.Component {

    fields = {
        nome: null,
        cpf: null,
        nuDDD: null,
        telefone: null,
        email: null,
    }
    constructor() {
        super()
        this.state = {
            loading: false,
            nome: { erro: false, value: '', name: 'nome' },
            cpf: { erro: false, value: '', name: 'cpf' },
            nuDDD: { erro: false, value: '', name: 'nuDDD' },
            telefone: { erro: false, value: '', name: 'telefone' },
            email: { erro: false, value: '', name: 'email' },
        }
    }

    componentDidMount() {
        console.log(this.props.options);

        this.setState({
            ...this.state,
            cpf: { erro: this.props.options.nmParticipante === '', value: this.props.options.nmParticipante, name: this.state.cpf.name },
            email: { erro: this.props.options.edEmail === '', value: this.props.options.edEmail, name: this.state.email.name },
            telefone: { erro: this.props.options.nuTelefone === '', value: this.props.options.nuTelefone, name: this.state.telefone.name }
        })

    }
    render() {

        const reminder = <span>*</span>
        const errorClass = 'act'

        const inputNome = <input fluid='true' ref={(c) => this.fields.nome = c}
            placeholder={Mensagens.p15}
            value={this.state.nome.value}
            type='text'
            onBlur={(e) => this.onLostFocus(this.state.nome.name, e.target.value)}
            onChange={(e) => this.onTextChanged(this.state.nome.name, e.target.value)} />
        const inputCPF = <MaskedInput mask={[/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/,]}
            type='text'
            fluid='true'
            name={this.state.cpf.name}
            size='14'
            placeholder={Mensagens.p16}
            guide={true}
            ref={(c) => this.fields.cpf = c}
            onBlur={(e) => this.onLostFocus(this.state.cpf.name, e.target.value)}
            onChange={(e) => this.onTextChanged(this.state.cpf.name, e.target.value)}
            value={this.state.cpf.value} />
        const inputTelefone = <MaskedInput mask={['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            type='text'
            fluid='true'
            name={this.state.telefone.name}
            size='14'
            guide={true}
            placeholder={Mensagens.p17}
            ref={(c) => this.fields.telefone = c}
            onChange={(e) => this.onTextChanged(this.state.telefone.name, e.target.value)}
            onBlur={(e) => this.onLostFocus(this.state.telefone.name, e.target.value)}
            value={this.state.telefone.value} />
        const inputEmail = <input fluid='true' ref={(c) => this.fields.email = c}
            placeholder={Mensagens.p18}
            value={this.state.email.value}
            type='email'
            onBlur={(e) => this.onLostFocus(this.state.email.name, e.target.value)}
            onChange={(e) => this.onTextChanged(this.state.email.name, e.target.value)} />

        return <Segment disabled={this.state.loading} loading={this.state.loading} className='resetBackground resetCorners resetBorders'  >
            <div className="form boxMargin">
                <MediaQuery minWidth={600}>
                    <div className="row">
                        <div className={`col ${this.state.nome.erro ? errorClass : ''}`}>
                            {inputNome}
                            {this.state.nome.erro && reminder}
                        </div>
                    </div>

                    <div className="row">
                        <div className={`col ${this.state.cpf.erro ? errorClass : ''}`}>
                            {inputCPF}
                            {this.state.cpf.erro && reminder}
                        </div>
                        <div className={`col ${this.state.telefone.erro ? errorClass : ''}`}>
                            {inputTelefone}
                            {this.state.telefone.erro && reminder}
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col ${this.state.email.erro ? errorClass : ''}`}>
                            {inputEmail}
                            {this.state.email.erro && reminder}
                        </div>
                    </div>
                </MediaQuery>
                <MediaQuery maxWidth={599}>
                    <div >
                        <div className={`col ${this.state.nome.erro ? errorClass : ''}`}>
                            {inputNome}
                            {this.state.nome.erro && reminder}
                        </div>
                    </div>
                    <div >
                        <div className={`col ${this.state.cpf.erro ? errorClass : ''}`}>
                            {inputCPF}
                            {this.state.cpf.erro && reminder}
                        </div>
                        <div className={`col ${this.state.telefone.erro ? errorClass : ''}`}>
                            {inputTelefone}
                            {this.state.telefone.erro && reminder}
                        </div>
                    </div>
                    <div >
                        <div className={`col ${this.state.email.erro ? errorClass : ''}`}>
                            {inputEmail}
                            {this.state.email.erro && reminder}
                        </div>
                    </div>
                </MediaQuery>

                <div style={{ textAlign: 'center' }}>

                    <MediaQuery minWidth={600}>
                        <Button className='button' color='grey' type='button' onClick={() => this.onCancel()}>{Mensagens.b23}</Button>
                        <Button className='button type2' type='button' onClick={() => this.onReset()}>{Mensagens.b22}</Button>
                    </MediaQuery>

                    <Button className='button type1' type='submit' onClick={() => this.onClick()}  >{Mensagens.b21}</Button>

                    <MediaQuery maxWidth={599}>
                        <Button className='button type2' type='button' onClick={() => this.onReset()}>{Mensagens.b22}</Button>
                        <Button className='button' color='grey' type='button' onClick={() => this.onCancel()}>{Mensagens.b23}</Button>
                    </MediaQuery>
                </div>
            </div>
        </Segment>
    }

    onLostFocus = (name, value) => {
        this.setValidationError(name, value)
    }
    onTextChanged = (name, value) => {

        this.setState({
            ...this.state,
            [name]: { value: value, erro: value === '', name: name }
        })
    }

    setValidationError(name, value) {

        let condicao = !value || value === ''
            || ((name === this.state.cpf.name || name === this.state.telefone.name) && value.includes('_'))
            || (name === this.state.email.name && (!value.includes('@') || !value.includes('.') || value.endsWith('.')))


        return new Promise((resolve, reject) => {
            if (name !== '')
                this.setState({
                    ...this.state,
                    [name]: { value: value, erro: condicao, name: name }
                }, () => resolve())
        })
    }
    onClick = () => {

        this.setValidationError(this.state.nome.name, this.state.nome.value).then(x => {
            this.setValidationError(this.state.cpf.name, this.state.cpf.value).then(x => {
                this.setValidationError(this.state.telefone.name, this.state.telefone.value).then(x => {
                    this.setValidationError(this.state.email.name, this.state.email.value).then(x => {
                        this.validarLogin()
                    })
                })
            })

        })
    }

    validarLogin = () => {

        let icValido = !this.state.cpf.erro
            && !this.state.nome.erro
            && !this.state.nuDDD.erro
            && !this.state.telefone.erro
            && !this.state.email.erro

        this.setState({
            ...this.state,
            loading: icValido

        }, () => {
            if (icValido) {
                if (this.props.onLogin) {

                    var p = {
                        nmParticipante: this.state.nome.value,
                        nuCPF: this.state.cpf.value,
                        nuDDD: this.state.nuDDD.value,
                        nuTelefone: this.state.telefone.value,
                        edEmail: this.state.email.value,
                        icCadastro: true
                    }

                    this.props.onLogin('', '', 3, p).then(result => {
                        this.setState({ message: result.Mensagem, loading: false })
                    })
                }
            }

        })
    }
    onReset = () => {

        this.setState({
            ...this.state,
            nome: { erro: false, value: '', name: 'nome' },
            cpf: { erro: false, value: '', name: 'cpf' },
            nuDDD: { erro: false, value: '', name: 'nuDDD' },
            telefone: { erro: false, value: '', name: 'telefone' },
            email: { erro: false, value: '', name: 'email' },
        })

        this.fields.nome.focus()
    }

    onCancel = () => {
        if (this.props.onCancel)
            this.props.onCancel()
    }
}

export default InscricaoExterno


// WEBPACK FOOTER //
// ./src/components/Usuarios/InscricaoExterno.js